import storage from "~/services/storage"

type useFetchType = typeof useFetch

export const useAuthFetch: useFetchType = (path, options = {}) => {
  const token = storage.getAuthToken()
  const headers: HeadersInit = {
    "X-Auth-Token": token,
    "Content-Type": "application/json",
  }
  const mergedOptions = {
    ...options,
  }

  return useFetch(path, {
    ...mergedOptions,
    headers,
    baseURL: `${useRuntimeConfig().public.apiBase}/api`,
  })
}

export const useAsyncAuthFetch = async (path: string, options = {}) => {
  return await $fetch(path, {
    baseURL: `${useRuntimeConfig().public.apiBase}/api`,
    headers: {
      "X-Auth-Token": storage.getAuthToken(),
      "Content-Type": "application/json",
    },
    ...options
  })
}
